module.exports = __webpack_public_path__ + "static/media/ad1cd90c-7793-4c0a-a7ce-4a6122b0e265.66f1670c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/ad1cd90c-7793-4c0a-a7ce-4a6122b0e265.woff
// module id = 80
// module chunks = 0